import { Image, Space } from 'antd';
import { map } from 'lodash';
import React, { useState } from 'react';
import { FALLBACK_PDF_URL, GA_EVENT, GA_LABEL } from '../common/constants';
import { Event } from '../common/trackEvents';

const AttachmentViewer = ({ attachments = {} }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [previewKey, setPreviewKey] = useState('');

  // Flatten all attachment types (image/pdf, image/jpeg, etc.) into a single array
  const allAttachments = Object.entries(attachments || {}).reduce(
    (acc, [type, files]) => {
      if (Array.isArray(files)) {
        return [
          ...acc,
          ...files.map((file) => ({
            key: file?.key,
            value: file?.value,
            type,
          })),
        ];
      }
      return acc;
    },
    [],
  );

  if (!allAttachments?.length) {
    return '-';
  }

  const isPDF = (type) => type?.includes('pdf');

  return (
    <div className="attachment-viewer">
      <Space className=" attachment-images" wrap>
        {map(allAttachments, (attachment, index) => (
          <div key={attachment?.key || index} className="attachment-item">
            <Image.PreviewGroup
              preview={{
                visible: isPDF(attachment?.key)
                  ? false
                  : previewKey === attachment?.key && isVisible,
                onVisibleChange: (visible) => {
                  setIsVisible(visible);
                  if (visible) {
                    Event(GA_EVENT.OPENED_IMAGE_VIEWER, {
                      label: GA_LABEL.OPENED_IMAGE_VIEWER,
                      // eslint-disable-next-line no-undef
                      pathname: window?.location?.href,
                    });
                  }
                },
              }}
            >
              <Image
                src={
                  isPDF(attachment?.key) ? FALLBACK_PDF_URL : attachment?.value
                }
                alt={attachment?.key}
                height="40px"
                width="40px"
                className="attachment-thumbnail"
                onClick={(e) => {
                  if (isPDF(attachment?.key)) {
                    e.preventDefault();
                    // eslint-disable-next-line no-undef
                    window.open(attachment?.value, '_blank');
                  } else {
                    setIsVisible(true);
                    setPreviewKey(attachment?.key);
                  }
                }}
              />
            </Image.PreviewGroup>
          </div>
        ))}
      </Space>
    </div>
  );
};

export default AttachmentViewer;
